import { AccountTopAppsMetricsSummaryEntity } from '../../../../src/core/domain/entities/top-apps/account-top-apps-metrics-summary.entity';
import { Mapper } from '../../../common/ddd/mapper.base';
import { IOrgAnalyticsActivityEnum } from '../../../common/enum/org-analytics-activity/org-analytics-activity.enum';

export interface IAccountTopAppsMetricsSummaryPersistenceResponse {
  [IOrgAnalyticsActivityEnum.AppId]: string;
  [IOrgAnalyticsActivityEnum.UserId]: string;
  [IOrgAnalyticsActivityEnum.DayCount]: string;
  [IOrgAnalyticsActivityEnum.TotalDuration]: string;
  [IOrgAnalyticsActivityEnum.Count]: string;
  [IOrgAnalyticsActivityEnum.LocalStartDate]: string;
}

export class AccountTopAppsMetricsSummaryMapper
  implements
    Omit<Mapper<AccountTopAppsMetricsSummaryEntity, any>, 'toResponse'>
{
  toDomain(
    record: IAccountTopAppsMetricsSummaryPersistenceResponse
  ): AccountTopAppsMetricsSummaryEntity {
    return AccountTopAppsMetricsSummaryMapper.toDomain(record);
  }
  static toDomain(
    record: IAccountTopAppsMetricsSummaryPersistenceResponse
  ): AccountTopAppsMetricsSummaryEntity {
    const entity = AccountTopAppsMetricsSummaryEntity.create({
      totalViews: Number(record[IOrgAnalyticsActivityEnum.TotalDuration]),
      count: Number(record[IOrgAnalyticsActivityEnum.Count]),
      userId: String(record[IOrgAnalyticsActivityEnum.UserId]),
      dayCount: Number(record[IOrgAnalyticsActivityEnum.DayCount]),
      appId: String(record[IOrgAnalyticsActivityEnum.AppId]),
      day: record[IOrgAnalyticsActivityEnum.LocalStartDate],
    });
    return entity;
  }
}
